import angular from 'angular';
import displaySystemComponent from './displaySystem.component';

let displaySystemModule = angular.module('displaySystem', [])

.component('displaySystem', displaySystemComponent)

.name;

export default displaySystemModule;



// WEBPACK FOOTER //
// ./client/app/components/displaySystem/displaySystem.js